import React, { useState, useEffect } from 'react';
import {} from 'reactstrap';
import PageBreadcrumb from '../../Components/Common/PageBreadcrumb';
import { getAuthToken, isAuthenticated } from '../../auth/tokenvalidation';
import notify, { MESSAGES } from '../../utils/notify';
import './FreightCostView.css';
import '../TenderOpening/components/TenderOpening.css';
// This page lists Product Hydro freight costs only (ProcurementTypeHeader = 1,
// set in ProductHydroTable).
import ProductHydro from './component/ProductHydro';

const FreightCostView = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const token = getAuthToken();

  // Authentication validation
  useEffect(() => {
    if (!token) {
      notify.error(MESSAGES.authRequired);
      return;
    }
    if (!isAuthenticated()) {
      notify.error(MESSAGES.authRequired);
      return;
    }
  }, [token]);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <React.Fragment>
      <div className='to-page email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
        <div className='email-content minimal-border'>
          <div className='p-4'>
            <div className='to-hero mb-4'>
              <PageBreadcrumb
                fallback={{
                  label: 'Freight Cost',
                  to: '/apps-freightcost/view',
                }}
              />

              <div className='d-flex align-items-center gap-3 flex-wrap'>
                <span className='to-hero-icon'>
                  <i className='ri-ship-line' aria-hidden='true' />
                </span>
                <div className='flex-grow-1'>
                  <h4 className='to-hero-title'>Freight Cost</h4>
                  <p className='to-hero-subtitle'>
                    Track freight cost requests per procurement and see which
                    ones already have a freight cost available.
                  </p>
                </div>
                <button
                  type='button'
                  className='to-hero-btn'
                  onClick={handleRefresh}
                >
                  <i className='ri-refresh-line' aria-hidden='true' />
                  Refresh
                </button>
              </div>
            </div>

            <ProductHydro
              refreshTrigger={refreshTrigger}
              exportName='Product Hydro'
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(FreightCostView);
